import { Component, input, OnInit, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-filter',
  imports: [
    TranslocoPipe,
    MatCard,
    MatCardContent,
    MatCardTitle,
    MatCardHeader,
    MatSelect,
    MatOption,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatIcon
  ],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent implements OnInit {
  label = input<string>();
  panelWidth = input<string>();
  selectItemGroups = input<{ parent: string; children: string[] }[]>();
  searchItemGroups = input<{ title: string }[]>();
  searchControls: Record<string, FormControl> = {};
  selectControls: Record<string, FormControl> = {};
  readonly refresh = output<void>();


  ngOnInit() {
    const selectGroups = this.selectItemGroups();
    if (selectGroups) {
      selectGroups.forEach(group => {
        this.selectControls[group.parent] = new FormControl('');
      });
    }

    const searchGroups = this.searchItemGroups();
    if (searchGroups) {
      searchGroups.forEach(group => {
        this.searchControls[group.title] = new FormControl('');
      });
    }
  }

  onRefresh(): void {
    Object.keys(this.selectControls).forEach((key) => {
      this.selectControls[key].setValue(null);
    });

    Object.keys(this.searchControls).forEach((key) => {
      this.searchControls[key].setValue('');
    });

    // TODO: The 'emit' function requires a mandatory void argument
    this.refresh.emit();
  }
}
